import { createSlice } from "@reduxjs/toolkit";

const initialState= {
    documents: null,
}

const adminDocumentSlice = createSlice({
    name: "admindocuments",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
         .addCase('LOGOUT', (state) => {
            Object.assign(state, initialState);
         })
    },
    reducers:{
        storeDocuments: (state, action) => {
            state.documents= action.payload;
        },
        addDocumentToStore: (state, action) => {
            let docs= state.documents&&state.documents.records;
            docs= docs ? [...docs, action.payload] : [action.payload]
            state.documents= {...state.documents, records: docs};
        },
        editDocumentInStore: (state, action) => {
            let docs= state.documents&&state.documents.records;
            let updatedDocs= docs.map((doc)=>{
                if(action.payload && doc.id === action.payload.id){
                    return action.payload
                }else{
                    return doc
                }
            });
            state.documents= {...state.documents, records: updatedDocs};
        },
        clearDocumentStore: (state) => {
            state.documents= null
        }
    }
})

export const { storeDocuments, addDocumentToStore, editDocumentInStore, clearDocumentStore } = adminDocumentSlice.actions
export default adminDocumentSlice.reducer